import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";

import InputField from "../input-field";
import StyledChatInput from "./styles";

const ChatInput = () => {
  const dispatch = useDispatch();

  const { currentChat, api } = useSelector((state) => state.chat);
  const { loading } = api;
  const { hasAccepted, inputDisabled } = currentChat;

  const onSendHandler = (value) => {
    dispatch(CHAT_ACTIONS.sendMessage({ type: "text", content: value }));
  };

  const onImageSendHandler = (value) => {
    dispatch(CHAT_ACTIONS.sendMessage({ type: "image", content: value }));
  };

  return (
    <StyledChatInput>
      <InputField
        onSend={onSendHandler}
        onSendImage={onImageSendHandler}
        noActive={!hasAccepted || loading || inputDisabled}
      />
    </StyledChatInput>
  );
};

export default ChatInput;
